(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("tenantResource", ["$resource", tenantResource]);
    function tenantResource($resource) {
        return $resource("/api/tenants/:area/:action", { action: "@action", area: "@area" }, {
            getSettings: {
                method: "GET",
                params: { action: "settings" }
            },
            removeSettingsFromCache: {
                method: "POST",
                params: { action: "remove-settings-from-cache" }
            },
            getSettingPages: {
                method: "GET",
                params: { area: "settings", action: "pages" }
            },
            getDataPrivacyView: {
                method: "GET",
                params: { area: "dataPrivacy" }
            },
            saveDataPrivacy: {
                method: "POST",
                params: { area: "dataPrivacy" }
            },
            getLogoCustomization: {
                method: "GET",
                params: { area: "logo" }
            },
            getFooterSettings: {
                method: "GET",
                params: { area: "footer-settings" }
            },
            saveFooterSettings: {
                method: "POST",
                params: { area: "footer-settings" }
            },
            cropLogo: {
                method: "POST",
                params: { area: "logo", action: "crop" }
            },
            getSignatureCustomization: {
                method: "GET",
                params: { area: "signature" }
            },
            deleteSignature: {
                method: "DELETE",
                params: { area: "signature" }
            },
            cropSignature: {
                method: "POST",
                params: { area: "signature", action: "crop" }
            },
            getLanguages: {
                method: "GET",
                params: { area: "languages" }
            },
            saveLanguages: {
                method: "POST",
                params: { area: "languages" }
            },
            getContactPreferences: {
                method: "GET",
                params: { area: "contactPreferences" }
            },
            saveContactPreferences: {
                method: "POST",
                params: { area: "contactPreferences" }
            },
            saveColors: {
                method: "POST",
                params: { area: "colors" }
            },
            getLogoPalette: {
                method: "GET",
                params: { area: "colors", action: "logoPalette" }
            },
            getCountriesList: {
                method: "GET",
                params: { area: "countries" }
            },
            getTimeZone: {
                method: "GET",
                params: { area: "timeZone" }
            },
            saveTimeZone: {
                method: "POST",
                params: { area: "timeZone" }
            },
            getLocation: {
                method: "GET",
                params: { area: "location" }
            },
            updateLocation: {
                method: "POST",
                params: { area: "location" }
            },
            checkSubscription: {
                method: "GET",
                params: { action: "checkSubscription" }
            },
            getDashboardTenancySetupViewModel: {
                method: "GET",
                params: { action: "dashboardTenancySetupViewModel" }
            },
            saveDefaultLoginPage: {
                method: "POST",
                params: { action: "defaultLoginPage" }
            },
            saveUserOptions: {
                method: "POST",
                params: { action: "userOptions" }
            },
            getSettingsGeneralSearchEngine: {
                method: "GET",
                params: { action: "settingsGeneralSearchEngine" }
            },
            saveSettingsGeneralSearchEngine: {
                method: "POST",
                params: { action: "settingsGeneralSearchEngine" }
            }
        });
    }
}());
